export function initialize() {
    let cookieBar = document.querySelector('.eu-cookies');

    if(cookieBar) {
        cookieBar.querySelector('button').onclick = function () {
            let date = new Date();
            date.setFullYear(date.getFullYear() + 10);
            document.cookie = 'eu-cookies=1; path=/; expires=' + date.toGMTString();
            cookieBar.style.display = 'none';
        };
    }
}
